import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import { colors } from "../../../constants/colors";

const styles = createUseStyles((theme) => ({
  modalContent: {
    margin: "22px 0 0 0"
  },
  footerBtns: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  checkbox: {
    marginRight: "12px"
  },
  modal: {
    width: "480px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    },
    "& .modal-content":{
      padding:"24px",
    },
    "& .modal-body":{
      padding: "0px"
    },
    "& .modal-header":{
      padding:"0px",
      "& div": {
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "30px",
        right: "30px"
      }
    },
  },
  disableClose: {
    "& .btn-close": {
      pointerEvents: "none"
    }
  },
  cancelBtn: {
    extend: "footerBtns",
    margin: "0 0 10px"
  },
  saveBtn: {
    extend: "footerBtns"
  },
  description: {
    fontSize: "14px",
    marginBottom: "20px"
  },
  download: {
    marginLeft: "5px",
    fontSize: "14px",
    fontWeight: "600",
    color: theme.buttons.defaultLink.color,
    textDecoration:"none"
  },
  dropzone: {
    marginBottom: "0",
    details: {
      margin: "20px"
    }
  },
  uploadIcon: {
    textAlign: "center"
  }
}));

export default styles;
